import { render, staticRenderFns } from "./ConfigCode.vue?vue&type=template&id=140f8700&"
import script from "./ConfigCode.vue?vue&type=script&lang=js&"
export * from "./ConfigCode.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports